import { JsonPipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;
declare var google: any;
@Component({
  selector: 'app-fleet-management',
  templateUrl: './fleet-management.component.html',
  styleUrls: ['./fleet-management.component.css']
})
export class FleetManagementComponent implements OnInit {

  

  userInfo: any;
  vehicleCheckIn: boolean;

  @Input() set filterDate(val: any) {
    if (val) {
      this.selFilteredDate = val;
      this.getEmployeeList(val);
    }
  }
  @Input() set branchChoosen(val: any) {
    if (val) {
      this.choosenBranch = val;
      if (this.selFilteredDate == undefined) {
        this.getEmployeeList();
      } else {
        this.getEmployeeList(this.selFilteredDate);
      }
    } else {
      this.choosenBranch = [];
    }
  }
  public fleetData: any = [];
  public fleetFilterData: any = [];
  public selectedEmps: any = [];
  public selectedGroup: any = {};
  public statusUpdateForm: FormGroup;
  public showStatusUpdateForm: boolean = false;
  public statusFormSubmitted: boolean = false;
  public statusList: any = {};
  public isAnyChangesHere: boolean = false;
  public finalObj: any = {};
  public selectedBranch: any = [];
  public branchInformation: any = {};
  public checkInOutID: string = '';
  public updateVehData: any = [];
  public checkInDate: number = 0;
  public storedData: any = [];
  public selFilteredDate: number;
  public isRouteCompleted: boolean = false;
  public modalTitle: string = 'Trip update';
  public orgID: string = '';
  public vendorID: string = '';
  public availableDrivers: any = [];
  public vehicleListArr: any = [];
  public choosenBranch: any = [];
  public endTripForm: FormGroup;
  public availTripStatus: any = [{ id: 1, value: 'yettostart', status: 'Yet to start' },
  { id: 2, value: 'start', status: 'Inprogress' }, { id: 3, value: 'end', status: 'End' }, { id: 4, value: 'completed', status: 'Completed' }, { id: 5, value: 'breakdown', status: 'Breakdown' }, { id: 6, value: 'Cancel', status: 'Cancelled' },
  ]

   expandedRows: number[] = [];

  @ViewChild('TripstatusFilter') TripstatusFilter: ElementRef;
  @ViewChild('enTripModalBtn') enTripModalBtn: ElementRef;
  @ViewChild('updateModalBtn') updateModalBtn: ElementRef;
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    private com: CommonServices,
    private mapService: MapService,
    private routeservice: RouteService,
    public formBuilder: FormBuilder
  ) {
    if (this.storage.get('userInfo').branch && this.storage.get('userInfo').branch.length > 0) {
      this.selectedBranch = this.storage.get('userInfo').branch;
    }
    this.orgID = this.storage.get('userInfo').orgID;
    this.getBranchList();
    this.userInfo = this.storage.get('userInfo')
    if ((this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].checked == false || this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].indeterminate == false) && this.userInfo.fieldMap['Route / Rostering'].menu1['Roster'].menu2['Vehicle Check In'].checked == false) {
      this.vehicleCheckIn = false;
    } else {
      this.vehicleCheckIn = true;
    }
  }
  get f() { return this.endTripForm.controls; }
  ngOnInit(): void {

    this.statusUploadFormLoad();
    if (this.selFilteredDate == undefined) {
      setTimeout(() => {
        // this.getEmployeeList();
        this.getVehicleList();
      }, 1000)
    }
    this.endTripForm = this.formBuilder.group({
      startKlMtr: ['', [Validators.required]],
      tripEndKlMtr: ['', [Validators.required]]
    })
  }
  getBranchList() {
    let data = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(data).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
        }
        if (this.selectedBranch == undefined || this.selectedBranch.length <= 0) {
          this.selectedBranch = Object.keys(this.branchInformation)
        }
        setTimeout(() => {
          this.getVehicleCheckInList();
        }, 100)
      } else {
        this.selectedBranch = [];
        this.branchInformation = {};
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getVehicleCheckInList() {
    if (this.vehicleCheckIn == true) {
      const obj = {
        "branch": this.choosenBranch,
        "type": ["out", "in"],
      };
      this.api.transportManagerCheckInOutList(obj).then((res: any) => {
        if (res && res.status == 'success') {
          if (res['data'] && res['data'].length > 0) {
            this.updateVehData = res['data'];
            this.checkedNotAssignedveh = res['data'].filter(e => e.type == 'in' && !e.routeAssign);
            // this.checkInOutID=res['data'][0]['checkInOutID'];
          } else {
            this.checkInOutID = '';
            this.updateVehData = [];
          }
        } else {
          this.checkInOutID = '';
          this.updateVehData = [];
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    else if (this.vehicleCheckIn == false) {

      this.api.transportManagerAllVehicleList('').then((res: any) => {
        if (res.status == 'success') {
          if (res['data'] && res['data'].length > 0) {
            this.updateVehData = res['data'];
            this.checkedNotAssignedveh = res['data']
          } else {
            this.checkInOutID = '';
            this.updateVehData = [];
          }
        } else {
          this.checkInOutID = '';
          this.updateVehData = [];
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  getEmployeeList(date?) {
    let apiObj={
      rosterStatus:['Fleet management']
    };
    // if(this.storage.get('userInfo').userType!='admin'){
    // }
    apiObj['branchID']=this.choosenBranch;
    // if(date){
    //   apiObj['tripDate']=date;
    // }else{
    //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // }
    // let currentDate=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // if(this.selFilteredDate==undefined || this.selFilteredDate==currentDate){
    //   // apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    //   apiObj['tripDate']= this.selFilteredDate;
    //   apiObj['istoday']=true;
    //   this.addEmpGroup.tripDate=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // }else{
    //   apiObj['tripDate']=this.selFilteredDate;
    //   apiObj['istoday']=false;
    //   this.addEmpGroup.tripDate=this.selFilteredDate;
    // }


    let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  let currentDateTime = currentDate.getTime();

  if (this.selFilteredDate == undefined || this.selFilteredDate == currentDateTime) {
    // use today's date at midnight
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    apiObj['tripDate'] = today.getTime();
    // console.log("date to set Hours::::::::", apiObj['tripDate']);
    
    apiObj['istoday'] = true;

    this.addEmpGroup.tripDate = today.getTime();
  } else {
    // normalize the selected date also
    let selDate = new Date(this.selFilteredDate);
    selDate.setHours(0, 0, 0, 0);

    apiObj['tripDate'] = selDate.getTime();
    apiObj['istoday'] = false;

    this.addEmpGroup.tripDate = selDate.getTime();
  }
    this.api.transportManagerGrouping(apiObj).then(async(res:any)=>{
      if (res && res.status == 'success') {
        // console.log("fleetManagment res::::::::", res);
        
        if(res.data[0]['fleetManagment'] && res.data[0]['fleetManagment'].length>0){
          this.fleetData= await this.com.sortGroupByShiftTime(res.data[0]['fleetManagment'],'shiftTime');
          this.storedData=JSON.parse(JSON.stringify(res.data[0]['fleetManagment']));
        }else{
          this.fleetData=[];
        }
        
        
        for (let fleet of this.fleetData) {
            if (fleet['routeType'] == "openBooking") {
              fleet['routeBadge'] = "OB";
              fleet['routeType_title'] = "Open booking route";
            } if (fleet['routeType'] == "regular") {
              fleet['routeBadge'] = "RE";
              fleet['routeType_title'] = "Regular route";
            } if (fleet['routeType'] == "occasional") {
              fleet['routeBadge'] = "OC";
              fleet['routeType_title'] = "Occasional route";
            } if (['roster', 'Roster', undefined].includes(fleet['routeType']) || fleet.hasOwnProperty('rosterID')) {
              fleet['routeBadge'] = "RO";
              fleet['routeType_title'] = "Roster route";
          }
        }
        // Set fleetFilterData for filtering functionality
        this.fleetFilterData = JSON.parse(JSON.stringify(this.fleetData));
        this.getGroupingData();
        this.getAddEmpList();
      }else{
        this.fleetData=[];
        this.fleetFilterData=[];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  
  public adhocResList: any = [];
  public reschedulecResList: any = [];
getAddEmpList(){
    let adhoc_arr=[];
    let obj = {
      tripDate: new Date(this.addEmpGroup.tripDate).getTime(),
      branchID: this.choosenBranch[0],
      // search:this.searchedValue
    }
    this.api.transportManagerGetEmployeeList(obj).then((res: any) =>
      //this.api.transportManagerRosterAdhocEmployeeList(obj).then((res: any) => 
      {
        console.log("get adhoc emp ::::", res);
        
            if(res.status=='success'){        
              this.adhocResList = res.adhoc;
              this.reschedulecResList=res.reschedule
            }
            if(res.emp.length>0){
              this.availableGroupEmps=[...this.availableGroupEmps,...res.emp]
            }

          if(res['adhoc'].length>0){
            let arr=[];
            adhoc_arr=res['adhoc'];
           
            for(let i=0;i<adhoc_arr.length;i++)
            {                                                                                     
              let tranistmode= this.capitalizeWords(adhoc_arr[i].transitMode);
              if(this.addEmpGroup.tripDate==adhoc_arr[i].date && (this.addEmpGroup.transitMode==tranistmode)){
                arr.push(adhoc_arr[i]);
              }
            }
            arr = arr.map(({ empName, ...rest }) => ({ name: empName, ...rest }));
            this.availableGroupEmps=[...this.availableGroupEmps,...arr]
          }
          if(res.reschedule.length>0){
            let reschedulearray=[]
           
            for(let i=0;i<res.reschedule.length;i++)
            {
              if(this.addEmpGroup.tripDate==res.reschedule[i].tripDate && (this.addEmpGroup.transitMode==res.reschedule[i].transitMode || res.reschedule[i].transitMode =='pickup' || res.reschedule[i].transitMode =='drop')){
                reschedulearray.push(res.reschedule[i])
              }
            }
            this.availableGroupEmps=[...this.availableGroupEmps,...reschedulearray]
          }
          // Remove duplicates based on empID and empRefID
          this.availableGroupEmps = this.availableGroupEmps.filter((item, index, self) =>
            index === self.findIndex(t =>
               t.empRefID === item.empRefID
            )
          );

          this.groupingEmps= this.availableGroupEmps;
         

      }).catch((err) => {
        console.log(err);
      });
  }

  // getEmployeeList(date?) {
  //   let apiObj = {
  //     rosterStatus: ['Fleet management', 'Cancel']
  //   };
  //   // if(this.storage.get('userInfo').userType!='admin'){
  //   // }
  //   apiObj['branchID'] = this.choosenBranch;
  //   // if(date){
  //   //   apiObj['tripDate']=date;
  //   // }else{
  //   //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
  //   // }
  //   let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
  //   if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
  //     apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
  //     apiObj['istoday'] = true;
  //   } else {
  //     apiObj['tripDate'] = this.selFilteredDate;
  //     apiObj['istoday'] = false;
  //   }
  //   let cancelData: any = []
  //   this.api.transportManagerGrouping(apiObj).then(async (res: any) => {

  //     console.log("res::::::::::", res);
  //     if (res && res.status == 'success') {
  //       if (res.data[0]['fleetManagment'] && res.data[0]['fleetManagment'].length > 0 || (res.data[0]['cancel'].length > 0)) {
  //         this.fleetData =  await this.com.sortGroupByShiftTime(res.data[0]['fleetManagment'], 'shiftTime');
  //         cancelData =  await this.com.sortGroupByShiftTime(res.data[0]['cancel'], 'shiftTime');
  //         if (cancelData && cancelData?.length > 0) {
  //           cancelData.forEach(data => this.fleetData.push(data));
  //         }
  //         this.fleetFilterData = this.fleetData;
  //         for (let fleet of this.fleetData) {
  //           if (fleet['routeType'] == "openBooking") {
  //             fleet['routeBadge'] = "OB";
  //             fleet['routeType_title'] = "Open booking route";
  //           } if (fleet['routeType'] == "regular") {
  //             fleet['routeBadge'] = "RE";
  //             fleet['routeType_title'] = "Regular route";
  //           } if (fleet['routeType'] == "occasional") {
  //             fleet['routeBadge'] = "OC";
  //             fleet['routeType_title'] = "Occasional route";
  //           } if (['roster', 'Roster', undefined].includes(fleet['routeType']) || fleet.hasOwnProperty('rosterID')) {
  //             fleet['routeBadge'] = "RO";
  //             fleet['routeType_title'] = "Roster route";
  //           }
  //         }
  //         this.storedData = JSON.parse(JSON.stringify(res.data[0]['fleetManagment']));
  //         // this.storedData = JSON.parse(JSON.stringify(this.tripStatusData[0]['fleetManagment']));
  //         console.log("fleetManagment storedData", this.storedData);
  //       } else {
  //         this.fleetData = [];
  //       }
  //       this.getGroupingData();
  //     } else {
  //       this.fleetData = [];
  //     }
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }
  

capitalizeWords(value: string): string {
    if (!value) return '';
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  getGroupingData() {
    let apiObj = {
      rosterStatus: ['Grouping']
    };
    // if(this.storage.get('userInfo').userType!='admin'){
    // }
    apiObj['branchID'] = this.choosenBranch;
    let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
      apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      apiObj['istoday'] = true;
    } else {
      apiObj['tripDate'] = this.selFilteredDate;
      apiObj['istoday'] = false;
    }
    this.api.transportManagerGrouping(apiObj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res.data[0]['grouping'] && res.data[0]['grouping'].length > 0) {
          this.storedGroupEmps = JSON.parse(JSON.stringify(res.data[0]['grouping']));
          this.findGroupEmps(res.data[0]['grouping']);
        } else {
          this.storedGroupEmps = [];
          this.groupingEmps = [];
          this.availableGroupEmps = [];
        }
      } else {
        this.storedGroupEmps = [];
        this.groupingEmps = [];
        this.availableGroupEmps = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  public statusCheckError = (controlName: string, errorName: string) => {
    return this.statusUpdateForm.controls[controlName].hasError(errorName);
  }
  public showEMpTable: boolean = false;
  public selectedGroupIndex = -1;
  openModal(index) {
    this.selectedGroupIndex = index;
    this.showEMpTable = true;
    let data = this.storedData[index];
    if (data?.tripStatus && data?.tripStatus == 'completed') {
      this.isRouteCompleted = true;
    } else {
      this.isRouteCompleted = false;
    }
    // routeType
    this.selectedGroup = data;
    this.selectedEmps = data?.empInfo;
    let vehData = this.updateVehData.filter(e => e.vehRegNo == data.vehRegNo);

    if (['regular', 'openBooking', 'occasional'].includes(data?.routeType)) {
      this.finalObj = {
        routeID: data?.routeID,
        routeDataID: data?._id,
        routeType: data?.routeType,
        type: 'Fleet management',
        tripDate: data?.tripDate,
        vehRegNo: data?.vehRegNo,
      }

    }
    if (['roster', undefined].includes(data?.routeType)) {
      this.finalObj = {
        type: 'Fleet management',
        tripDate: data?.tripDate,
        rosterID: data?.rosterID,
        checkInID: data?.vehInfo?.checkInID,
        vehRegNo: data?.vehRegNo,
        routeID: data?.routeID,
        transitMode: data?.transitMode,
        branchInfo: data?.branchInfo
      }
    }
    if (vehData && vehData?.length > 0) {
      if (this.vehicleCheckIn == true) {
        this.finalObj['date'] = vehData[0]['checkIn']['date'];
      }
      else {
        // this.finalObj['date']='';
      }
    }
    this.showStatusUpdateForm = true;
    if (data?.transitMode == 'pickup' || data?.transitMode == 'Pickup') {
      // this.statusList=['Boarded','Reschedule','No show','No need'];
      this.statusList = {
        "boarded": "Boarded",
        "reschedule": "Reschedule",
        "noShow": "No show",
        "noNeed": "No need",
        "deboarded": "Deboarded"
      }
    } else {
      // this.statusList=['Deboarded','Reschedule','No show','No need'];
      this.statusList = {
        // "notUtilized":'Not utilized',
        // "boarded": "Boarded",
        "deboarded": "Deboarded",
        "reschedule": "Reschedule",
        "noShow": "No show",
        "noNeed": "No need"
      }
    }
    // this.statusUploadToForm();
    setTimeout(() => {
      this.setValuesToForm(data);
    }, 100)
    document.getElementById('openStatusUpdateModalBtn')?.click();
    setTimeout(() => {
      this.setEndFieldDisable(data);
    }, 100)
  }
  setEndFieldDisable(data) {
    if (this.selectedEmps?.length > 0) {
      let isValid = false;
      for (let i = 0; i < this.selectedEmps?.length; i++) {
        if (this.selectedEmps[i]?.empTripStatus) {
          isValid = true;
        } else {
          isValid = false;
          break
        }
      }
      let endingKM: any = document.getElementById('endingKM');
      let tripStatus: any = document.getElementById('tripStatus');
      let acStatus: any = document.getElementById('acStatus');
      let startingKM: any = document.getElementById('startingKM');
      if (!isValid) {
        endingKM.disabled = ['Cancel', 'start',undefined].includes(data?.tripStatus) ? true : false;
        tripStatus.disabled = ['Cancel', 'start',undefined].includes(data?.tripStatus) ? true : false;
        acStatus.disabled = ['Cancel', 'start',undefined].includes(data?.tripStatus) ? true : false;
        // startingKM.disabled = false;
        startingKM.disabled = ['Cancel', undefined].includes(data?.tripStatus) ? true : false;
        // console.log("this.startingKM.disabled",startingKM.disabled)
      } else if (this.statusUpdateForm.value.tripStatus == 'completed') {
        endingKM.disabled = true;
        tripStatus.disabled = true;
        acStatus.disabled = true;
        startingKM.disabled = true;
      }
      else {
        endingKM.disabled = ['Cancel', 'start'].includes(data?.tripStatus) ? true : false;
        tripStatus.disabled = ['Cancel', 'start'].includes(data?.tripStatus) ? true : false;
        acStatus.disabled = ['Cancel', 'start'].includes(data?.tripStatus) ? true : false;
      }

    } else {
      if (['regular', 'openBooking', 'occasional'].includes(this.selectedGroup['routeType'])) {
        let endingKM: any = document.getElementById('endingKM');
        let tripStatus: any = document.getElementById('tripStatus');
        let acStatus: any = document.getElementById('acStatus');
        let startingKM: any = document.getElementById('startingKM');
        if (this.statusUpdateForm.value.tripStatus == 'completed') {
          endingKM.disabled = true;
          tripStatus.disabled = true;
          acStatus.disabled = true;
          startingKM.disabled = true;
        }
        else if (this.selectedGroup['tripStatus'] == 'end') {
          endingKM.disabled = false;
          startingKM.disabled = false;
          tripStatus.disabled = false;
          acStatus.disabled = false;
        } else {
          endingKM.disabled = true;
          tripStatus.disabled = true;
          acStatus.disabled = true;
          startingKM.disabled = false;
        }
      }
    }

  }
  statusUploadToForm() {
    for (let i = 0; i < this.selectedEmps.length; i++) {
      let name = 'empStatus' + this.selectedEmps[i].empRefID;
      this.statusUpdateForm.addControl(name, new FormControl(''));
    }
  }
  statusUploadFormLoad() {
    this.statusUpdateForm = new FormGroup({
      startingKM: new FormControl('', [Validators.required]),
      endingKM: new FormControl('', [Validators.required]),
      acStatus: new FormControl('', [Validators.required]),
      tripStatus: new FormControl('', [Validators.required]),
    })
  }
  setValuesToForm(data) {
       if (data['routeType'] && ['regular', 'openBooking', 'occasional'].includes(data['routeType'])) {
      // Set form for defined routeType
      this.statusUpdateForm = new FormGroup({
        startingKM: new FormControl(data['startingKM'] || '', data['tripStatus'] === 'start' ? [Validators.required] : []),
        endingKM: new FormControl(data['endingKM'] || '', data['tripStatus'] !== 'start' ? [Validators.required] : []),
        acStatus: new FormControl(''),
        tripStatus: new FormControl(['start', 'completed'].includes(data['tripStatus']) ? data['tripStatus'] : '', data['tripStatus'] !== 'start' ? [Validators.required] : []),
      });
    } else if (!data['routeType']) {
      // Set form for undefined routeType
      const isStartKeyPresent = !!data?.start;
      this.statusUpdateForm = new FormGroup({
        startingKM: new FormControl(data.start?.value || '', [Validators.required]),
        endingKM: new FormControl(data.end?.value || '', isStartKeyPresent && data.tripStatus != 'end' ? [] : [Validators.required]),
        acStatus: new FormControl(data.acStatus || ''),
        tripStatus: new FormControl(['start', 'completed'].includes(data['tripStatus']) ? data['tripStatus'] : '', isStartKeyPresent && data.tripStatus != 'end' ? [] : [Validators.required]),
      });
    }


    // for(let i=0;i<this.selectedEmps.length;i++){
    //   let name='empStatus'+this.selectedEmps[i].empRefID;
    //   let elem:any = document.getElementById(name);
    //   if(this.selectedEmps[i].empTripStatus=='Reschedule'){
    //     elem.disabled=true;
    //   }
    //   if(this.selectedEmps[i].empTripStatus){
    //     this.statusUpdateForm.controls[name].patchValue(this.selectedEmps[i].empTripStatus);
    //   }else{
    //     this.statusUpdateForm.controls[name].patchValue('');
    //   }
    // }
  }
  public disableEnd: boolean = true;
  fieldChange(value, field) {
    this.isAnyChangesHere = true;
    let obj = {};
    if (field == 'startingKM') {
      if (value != '') {
        this.disableEnd = false;
      } else {
        this.statusUpdateForm.patchValue({ endingKM: '' });
        this.disableEnd = true;
      }
      obj['start'] = {
        value: Number(value),
        time: Date.now()
      }
    } else if (field == 'endingKM') {
      obj['end'] = {
        value: Number(value),
        time: Date.now()
      }

    } else if (field == 'tripStatus') {
      obj['tripStatus'] = value;
      obj['end'] = {
        value: Number(this.statusUpdateForm.value.endingKM),
        time: Date.now()
      }
      obj['checkOutTimeStr'] = this.convertTimeStr(Date.now());
      if (this.selectedGroup['escortInfo'] != undefined) {
        obj['escortInfo'] = {
          'name': this.selectedGroup['escortInfo']['name'],
          'mobile': this.selectedGroup['escortInfo']['mobile'],
          'escortID': this.selectedGroup['escortInfo']['escortID'],
          'ecsortCheckInID': this.selectedGroup['escortInfo']?.escortCheckInID ? this.selectedGroup['escortInfo']['escortCheckInID'] : ''
        }
      }

    } else if (field == 'acStatus') {
      obj['acStatus'] = value;
    }
    this.finalObj = {
      ...this.finalObj,
      ...obj
    };
  }
  changeEmpStatus(id, value) {
    this.isAnyChangesHere = true;
    let name = 'empStatus' + id;
    let index = this.selectedEmps.findIndex(e => e.empRefID == id);
    if (index != -1) {
      this.selectedEmps[index]['empTripStatus'] = value;

      // if(this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
      // if(this.selectedEmps[index]['atten']) delete this.selectedEmps[index]['atten'];
      // if(this.selectedEmps[index]['attenExitTime']) delete this.selectedEmps[index]['attenExitTime'];
      // if(this.selectedEmps[index]['tripType']) delete this.selectedEmps[index]['tripType'];
      // if(this.selectedEmps[index]['shiftTimeStr']) delete this.selectedEmps[index]['shiftTimeStr'];
      // if(this.selectedEmps[index]['location']) delete this.selectedEmps[index]['location'];if(this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
      // if(this.selectedEmps[index]['area']) delete this.selectedEmps[index]['area'];
      // if(this.selectedEmps[index]['branchInfo']) delete this.selectedEmps[index]['branchInfo'];
      if (value == 'Boarded') {
        this.selectedEmps[index]['attenTime'] = Date.now();
        this.selectedEmps[index]['atten'] = true;
      } else if (value == 'Deboarded') {
        this.selectedEmps[index]['attenExitTime'] = Date.now();
        this.selectedEmps[index]['atten'] = true;
      } else if (value == 'Reschedule') {
        this.finalObj['tripType'] = this.selectedGroup['transitMode'];
        this.finalObj['shiftTimeStr'] = this.selectedGroup['shiftTimeStr'];
        this.finalObj['location'] = this.selectedGroup['location'];
        this.finalObj['area'] = this.selectedGroup['area'];
        this.selectedEmps[index]['statusNew'] = true;
        if (this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
        if (this.selectedEmps[index]['atten']) delete this.selectedEmps[index]['atten'];
        if (this.selectedEmps[index]['attenExitTime']) delete this.selectedEmps[index]['attenExitTime'];
      } else {
        if (this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
        if (this.selectedEmps[index]['atten']) delete this.selectedEmps[index]['atten'];
        if (this.selectedEmps[index]['attenExitTime']) delete this.selectedEmps[index]['attenExitTime'];
      }
      this.finalObj['empInfo'] = this.selectedEmps;
    }
  }
  closeModal() {
    this.statusUpdateForm.reset();
    
    // Store current filter value
    const currentFilterValue = this.TripstatusFilter.nativeElement.value;
    
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
    
    // Re-apply the filter after data is loaded
    setTimeout(() => {
      this.TripstatusFilter.nativeElement.value = currentFilterValue;
      this.filterChange(currentFilterValue);
    }, 100);
    
    this.selectedGroupIndex = -1;
    this.showEMpTable = false;
    this.selectedGroup = {};
    this.selectedEmps = [];
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.finalObj = {};
  }


   showNestedData(id: string, index: number) {
    const rowIndex = this.expandedRows.indexOf(index);
    
    if (rowIndex === -1) {
      // If index is not present, add it (expand)
      this.expandedRows.push(index);
    } else {
      // If index exists, remove it (collapse)
      this.expandedRows.splice(rowIndex, 1);
    }
    setTimeout(()=>{
      let btn=document.getElementById(id);
      if(btn.classList.contains('fa-chevron-down')){
          btn.classList.replace('fa-chevron-down','fa-chevron-up');
          btn.title='Hide employee';
        }else{
          btn.classList.replace('fa-chevron-up','fa-chevron-down');
          btn.title='Show employee';
      }
    },100)

    //this.openModal(index);
  }

  convertTimeStr(ms) {
    let d = new Date(ms),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    return h + ':' + m;
  }

  submitModal() {
    this.statusFormSubmitted = true;
    if (this.statusUpdateForm.valid && this.isAnyChangesHere) {

      if (this.finalObj?.routeType == 'regular' || this.finalObj?.routeType == 'openBooking' || this.finalObj?.routeType == 'occasional') {
        this.finalObj = {
          routeID: this.finalObj?.routeID,
          routeDataID: this.finalObj?.routeDataID,
          routeType: this.finalObj?.routeType,
          tripStatus: this.finalObj?.['tripStatus'] ? this.finalObj?.['tripStatus'] : this.statusUpdateForm.value.tripStatus ? this.statusUpdateForm.value.tripStatus : '',
          tripDate: this.finalObj?.tripDate,
          vehRegNo: this.finalObj?.['vehRegNo'],
          type: this.finalObj?.['type'],
          end: this.finalObj?.['end'],
          start: this.finalObj?.['start']
        }
        if (!this.finalObj?.start) delete this.finalObj.start;
        if (!this.finalObj?.end) delete this.finalObj.end;
      }
      // Store current filter value before API call
      const currentFilterValue = this.TripstatusFilter.nativeElement.value;
      
      this.api.transportManagerEditGrouping(this.finalObj).then((res: any) => {
        if (res && res.status == 'success') {
          this.fleetData = [];
          this.storedData = [];
          this.closeModal();
          
          // Reload data while preserving filter
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          
          // Re-apply the filter after data is loaded
          setTimeout(() => {
            this.TripstatusFilter.nativeElement.value = currentFilterValue;
            this.filterChange(currentFilterValue);
          }, 500);
          
          this.swal.swalFunction('success', res.status, res.message, 5000);
          document.getElementById('closeModalBtn')?.click();
          this.finalObj = {};
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
  refreshFleetManagement() {
    this.TripstatusFilter.nativeElement.value = 'All';
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
  }

  //Add employee to route
  public groupingEmps: any = [];
  public availableGroupEmps: any = [];
  public storedGroupEmps: any = [];
  public showAddEmpTable: boolean = false;
  public addEmpGroup: any = {};
  public selectedEmployees: any = [];
  public availableSeats: number = 0;
  findGroupEmps(data) {
    if (data && data.length > 0) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (this.selectedGroup.tripDate == data[i].tripDate && this.selectedGroup.transitMode == data[i].transitMode) {
          for (let j = 0; j < data[i]['empInfo'].length; j++) {
            data[i]['empInfo'][j]['oldRosterID'] = data[i]['rosterID'];
          }
          arr = [...arr, ...data[i]['empInfo']];
        }
      }
      this.groupingEmps = arr;
      this.showAddEmpTable = true;
    } else {
      this.groupingEmps = [];
    }
    this.availableGroupEmps = this.groupingEmps;
  }
  openAddEmp(group) {
    this.modalTitle = 'Add employee';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    if (group.escortInfo) {
      this.availableSeats = group.vehInfo.capacity - (group.empInfo.length + 1);
    } else {
      this.availableSeats = group.vehInfo.capacity - group.empInfo.length;
    }

    if (group.tripStatus === 'start') {
    const absentCount = group.empInfo.filter(
      emp => this.statusList[emp.empTripStatus] === 'No show'
    ).length;
    this.availableSeats += absentCount;
  }
  // console.log("availabel seats::::", this.availableSeats);
    this.addEmpGroup = group;
    this.findGroupEmps(this.storedGroupEmps);
    document.getElementById('openEmployeeAddBtn')?.click();
  }

  closeEmployeeAdd() {
    this.openModal(this.selectedGroupIndex);
    for (let i = 0; i < this.groupingEmps.length; i++) {
      if (this.groupingEmps[i].checked != undefined) delete this.groupingEmps[i].checked;
    }
    this.modalTitle = 'Trip update';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.availableSeats = 0;
    this.selectedEmployees = [];
    this.addEmpGroup = {};
    this.showAddEmpTable = false;
    this.groupingEmps = [];
    this.availableGroupEmps = [];
    // document.getElementById('closeEmployeeAddBtn')?.click();
  }
  customiseFinalObj() {
    return new Promise((res, rej) => {
      try {

        let checkedEmp = this.availableGroupEmps.filter(e => e.checked);
        let allEmps = [...checkedEmp, ...this.addEmpGroup['empInfo']];
        let apiObj = {
          rosterID: this.addEmpGroup.rosterID,
          empInfo: allEmps,
          removeEmp: [],
          driverID: [this.addEmpGroup.driverInfo.driverID]
        };
        if (this.selFilteredDate == undefined) {
          apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
        } else {
          apiObj['tripDate'] = this.selFilteredDate;
        }
        let removeObj = [];
        for (let i = 0; i < checkedEmp.length; i++) {
          let cusObj = {
            empRefID: [checkedEmp[i].empRefID],
            oldRosterID: checkedEmp[i].oldRosterID
          }
          let index = removeObj.findIndex((e: any) => e.oldRosterID == checkedEmp[i].oldRosterID);
          if (index != -1) {
            removeObj[index].empRefID.push(checkedEmp[i].empRefID);
          } else {
            removeObj.push(cusObj);
          }
        }
        apiObj['removeEmp'] = removeObj;
        res(apiObj);
      } catch (err) {
        console.log(err)
        rej(err)
      };
    })
  }
  triggerNotificationToDriver(id) {

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to trigger notification to this driver!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Send',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = {
          "notificationFor": "Driver",
          "driverID": [id]
        }
        this.api.transportManagerRosterTriggerNotificationToDriver(obj).then((res: any) => {
          this.swal.swalFunction(res.status, res.status, res.message, 5000);
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }
  async addEmployeeToRoute() {
    let obj = await this.customiseFinalObj();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to add these employees to this group!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#4caf50 ',
      confirmButtonText: 'Confirm',
      customClass: {
        cancelButton: 'order-1',
        confirmButton: 'order-2',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.transportManagerRosterAddEmployee(obj).then((res: any) => {
          if (res && res.status == 'success') {
            this.swal.swalFunction('success', res.status, res.message, 5000);
            this.closeEmployeeAdd();
            let closeBtn: any = document.getElementById('closeModalBtn');
            closeBtn.setAttribute("data-dismiss", "modal");
            closeBtn?.click();
            if (this.selFilteredDate == undefined) {
              this.getEmployeeList();
            } else {
              this.getEmployeeList(this.selFilteredDate);
            }
          } else {
            this.swal.swalFunction('error', res.status, res.message, 5000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }
  findEmployee(searchValue) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
    let data = this.groupingEmps.filter(e => e.name.toLowerCase().includes(searchValue.toLowerCase()) || e.empRefID.toLowerCase().includes(searchValue.toLowerCase()));
    this.availableGroupEmps = data;
  }
  selectAddEmployee(value, employee) {
    let index1 = this.availableGroupEmps.findIndex(e => e.employeeID == employee.employeeID);
    if (index1 != -1) {
      this.availableGroupEmps[index1]['checked'] = value;
    }
    this.selectedEmployees = this.availableGroupEmps.filter(e => e.checked);
  }

  //Swap Vehicle
  public swapVehicleForm: FormGroup;
  public swapVehFormSubmitted: boolean = false;
  public showSwapVehForm: boolean = false;
  public checkedNotAssignedveh: any = [];
  public selectedVehicle: any = [];
  public selectedDriver: any = [];
  public showVehicleError: boolean = false;

  loadSwapVehForm() {
    this.swapVehicleForm = new FormGroup({
      oldVehicle: new FormControl(this.selectedGroup.vehRegNo, [Validators.required]),
      oldVehCapacity: new FormControl(this.selectedGroup.vehInfo.capacity),
      newVehicle: new FormControl('', [Validators.required]),
      newVehCapacity: new FormControl(),
      driverName: new FormControl('', [Validators.required]),
      driverMobile: new FormControl('', [Validators.required]),
      reason: new FormControl('', [Validators.required]),
    })
    if (this.selectedGroup?.tripStatus && this.selectedGroup?.tripStatus == 'start') {
      this.swapVehicleForm.addControl('startingKM', new FormControl(this.selectedGroup.start && this.selectedGroup.start.value ? this.selectedGroup.start.value : '', [Validators.required]));
      this.swapVehicleForm.addControl('endingKM', new FormControl(this.selectedGroup.end && this.selectedGroup.end.value ? this.selectedGroup.end.value : '', [Validators.required]));
      this.swapVehicleForm.addControl('acStatus', new FormControl(this.selectedGroup.acStatus ? this.selectedGroup.acStatus : '', [Validators.required]));
      // this.swapVehicleForm.addControl('tripStatus',new FormControl('',[Validators.required]));
    }
  }
  openSwapVehicle() {
    this.modalTitle = 'Swap vehicle';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.showSwapVehForm = true;
    this.getVehicleCheckInList();
    this.loadSwapVehForm();
  }
  closeSwapVehicle() {
    this.openModal(this.selectedGroupIndex);
    this.modalTitle = 'Trip update';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.showSwapVehForm = false;
    this.swapVehFormSubmitted = false;
    this.checkedNotAssignedveh = [];
    this.vendorID = '';
    this.selectedDriver = [];
    this.swapVehicleForm.reset();
    this.statusUpdateForm.get('tripStatus')?.setValue('');
    if (this.selectedGroup?.tripStatus && this.selectedGroup?.tripStatus == 'start') {
      this.swapVehicleForm.patchValue({
        oldVehicle: '',
        newVehicle: '',
        driverName: '',
        driverMobile: '',
        reason: '',
        startingKm: '',
        endingKM: '',
        acStatus: '',
        // tripStatus:''
      })
    } else {
      this.swapVehicleForm.patchValue({
        oldVehicle: '',
        newVehicle: '',
        driverName: '',
        driverMobile: '',
        reason: '',
      })
    }
  }
  findNewVehicle(value) {
    return new Promise((res, rej) => {
      let data = this.vehicleListArr.filter(e => e.vehRegNo == value);
      res(data);
    })
  }
  async submitSwapVehicle() {
    this.swapVehFormSubmitted = true;
    let fillCapacity = this.selectedGroup.escortInfo ? this.selectedGroup.empInfo.length + 1 : this.selectedGroup.empInfo.length;
    if (fillCapacity > this.swapVehicleForm.value.newVehCapacity && this.swapVehicleForm.value.newVehicle != '') {
      this.showVehicleError = true;
    } else {
      this.showVehicleError = false;
    }
    let newVehData = await this.findNewVehicle(this.swapVehicleForm.value.newVehicle);
    let vehicle = this.updateVehData.filter(e => e.vehRegNo == this.swapVehicleForm.value.newVehicle);
    let vehInfo = {};
    if (newVehData) {
      vehInfo = {
        "capacity": newVehData[0]?.capacity,
        "vehType": newVehData[0]?.model,
        "checkInID": vehicle[0]?.checkInID
      }
    }
    if (this.swapVehicleForm.valid && !this.showVehicleError) {
      let obj = {};
      if (this.selFilteredDate == undefined) {
        obj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      } else {
        obj['tripDate'] = this.selFilteredDate;
      }

      obj['reason'] = this.swapVehicleForm.value.reason;
      obj['oldVehicle'] = this.swapVehicleForm.value.oldVehicle;
      obj['newVehicle'] = this.swapVehicleForm.value.newVehicle;
      obj['oldDriverID'] = this.selectedGroup.driverInfo.driverID;
      obj['rosterID'] = this.selectedGroup.rosterID;
      obj['vendor'] = this.vendorID;
      obj['transitMode'] = this.selectedGroup.transitMode;
      obj['shiftTimeStr'] = this.selectedGroup.shiftTimeStr;
      obj['oldVehicleInfo'] = {
        startKM: this.swapVehicleForm.value.startingKM,
        endKM: this.swapVehicleForm.value.endingKM,
        acStatus: this.swapVehicleForm.value.acStatus,
        // tripStatus:this.swapVehicleForm.value.tripStatus,
        tripStatus: this.selectedGroup?.tripStatus ? this.selectedGroup?.tripStatus : 'yetToStart',
      }
      obj['vehInfo'] = vehInfo;
      if (this.vehicleCheckIn == true) {
        obj['newDriverName'] = this.selectedDriver[0].driverInfo.name;
        obj['newDriverNumber'] = this.selectedDriver[0].driverInfo.mobile;
        obj['newDriverID'] = this.selectedDriver[0].driverInfo.driverID;
      }
      else if (!this.vehicleCheckIn) {
        obj['newDriverName'] = this.selectedDriver[0].name;
        obj['newDriverNumber'] = this.selectedDriver[0].mobile;
        obj['newDriverID'] = this.selectedDriver[0].driverID;
      }

      this.vehChangeApiSubmit(obj);
    }
  }
  vehChangeApiSubmit(obj: any) {
    this.api.transportManagerChangeVehicle(obj).then((res: any) => {
      if (res && res.status == 'Success') {
        this.swal.swalFunction('success', res.status, res.response, 5000);
        this.closeSwapVehicle();
        let closeBtn: any = document.getElementById('closeModalBtn');
        closeBtn.setAttribute("data-dismiss", "modal");
        closeBtn?.click();
        if (this.selFilteredDate == undefined) {
          this.getEmployeeList();
        } else {
          this.getEmployeeList(this.selFilteredDate);
        }
      } else {
        this.swal.swalFunction('error', res.status, res.response, 5000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  public swapVehicleCheckError = (controlName: string, errorName: string) => {
    return this.swapVehicleForm.controls[controlName].hasError(errorName);
  }
  getVehicleList() {
    // Get Vehicle List API
    const obj = {
      "branch": this.choosenBranch
    };
    this.api.transportManagerOverallVehList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          this.vehicleListArr = res['data'];
        } else {
          this.vehicleListArr = [];
        }
      } else {
        this.vehicleListArr = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getDriverList() {

    const driverObj = {
      orgID: this.orgID,
      vendorID: this.vendorID,
      // branch:this.choosenBranch
    };

    this.api.transportManagerDriverList(driverObj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res && res['data'] && res['data'].length > 0 && res['status'] && res['status'] == 'success') {
          if (this.vehicleCheckIn == true) {
            this.availableDrivers = res['data'];
          }
          else if (this.vehicleCheckIn == false) {
            this.availableDrivers = this.checkedNotAssignedveh;
          }
        } else {
          this.availableDrivers = [];
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  findSelectedVeh(value) {
    return new Promise((res, rej) => {
      let data = this.vehicleListArr.filter(e => e.vehRegNo == value);
      res(data);
    })
  }
  async setDriverDetails(value) {
    this.selectedVehicle = await this.findSelectedVeh(value);
    if (this.selectedVehicle.length > 0) {
      this.vendorID = this.selectedVehicle[0].vendorID
    }
    this.getDriverList();
    if (value != '') {
      let data = this.checkedNotAssignedveh.filter(e => e.vehRegNo == value);
      this.selectedDriver = data;
      if (this.vehicleCheckIn == true) {
        this.swapVehicleForm.patchValue({
          newVehCapacity: data[0].vehInfo.capacity,
          driverName: data[0]['driverInfo'].driverID,
          driverMobile: data[0]['driverInfo'].mobile
        })
      } else if (this.vehicleCheckIn == false) {
        this.swapVehicleForm.patchValue({
          newVehCapacity: data[0].capacity,
          driverName: data[0].driverID,
          driverMobile: data[0].mobile
        })
      }
    } else {
      this.swapVehicleForm.patchValue({
        newVehCapacity: '',
        driverName: '',
        driverMobile: ''
      })
    }
    let fillCapacity = this.selectedGroup.escortInfo ? this.selectedGroup.empInfo.length + 1 : this.selectedGroup.empInfo.length;
    if (fillCapacity > this.swapVehicleForm.value.newVehCapacity && this.swapVehicleForm.value.newVehicle != '') {
      this.showVehicleError = true;
    } else {
      this.showVehicleError = false;
    }
  }
  setDriverMobile(value) {
    if (value != '') {
      let data = this.availableDrivers.filter(e => e.driverID == value);
      this.selectedDriver = data;
      this.swapVehicleForm.patchValue({
        driverMobile: data[0].mobile
      })
    } else {
      this.swapVehicleForm.patchValue({
        driverMobile: ''
      })
    }
    let fillCapacity = this.selectedGroup.escortInfo ? this.selectedGroup.empInfo.length + 1 : this.selectedGroup.empInfo.length;
    if (fillCapacity > this.swapVehicleForm.value.newVehCapacity && this.swapVehicleForm.value.newVehicle != '') {
      this.showVehicleError = true;
    } else {
      this.showVehicleError = false;
    }
  }




  //Employee view in map
  public selectedMap: string = 'google';
  public googleMapObj: any;
  public locationMap: any;
  public markerId = 'pickLocation' + Math.round(Math.random() * 10000);
  public markersArray: any = [];

  public empLocs: any = [];
  public wayPoints: any = [];
  public routeLine: any;
  public plotPath: any;
  public plottedLines: any = [];
  public lineCoardinate: any = [];

  async viewEmpInMap(group) {
    this.modalTitle = 'Trip details';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.loadMap(group);
    setTimeout(() => {
    }, 10)

  }
  async customiseData(group) {

    let employees = JSON.parse(JSON.stringify(group.empInfo));
    if (group.branchInfo) {
      if (group.transitMode == 'Pickup') {
        employees.push(group.branchInfo);
      } else {
        employees.unshift(group.branchInfo);
      }
    }
    for (let i = 0; i < employees.length; i++) {
      if (employees[i].location && employees[i].location['lat'] && employees[i].location['lng']) {
        if (this.selectedMap == 'google') {
          let obj = {};
          if (employees[i].empRefID) {
            obj = {
              name: employees[i].name,
              ID: employees[i].empRefID,
              mobile: employees[i].mobile,
              type: 'Employee'
            }
            if (group.transitMode == 'Pickup') {
              obj['pp'] = i + 1;
            }
            if (group.transitMode == 'Drop') {
              obj['dd'] = i;
            }
          } else {
            obj = {
              name: employees[i].name,
              type: 'Branch'
            }
          }
          let arr = [
            employees[i].location['lat'],
            employees[i].location['lng'],
            { pp: true }
          ]
          this.empLocs.push(arr);
          this.placeMarker(employees[i].location['lat'], employees[i].location['lng'], obj);
        } else {
          this.locationMarker(employees[i].location['lat'], employees[i].location['lng']);
        }
      }
    }
    for (let i = 0; i < this.empLocs.length; i++) {
      if (i > 0) {
        let arr = [this.empLocs[i - 1], this.empLocs[i]];
        let points: any = await this.routeservice.findWayPoints(arr);
        this.wayPoints = [...this.wayPoints, ...points];
      }
    }
    if (this.wayPoints.length > 0) {
      for (let l = 0; l < this.wayPoints.length; l++) {
        let obj = {
          lat: +this.wayPoints[l][0],
          lng: +this.wayPoints[l][1]
        }
        this.lineCoardinate.push(obj);
      }
      for (let m = 0; m < this.lineCoardinate.length; m++) {
        if (m > 0) {
          let arr = [this.lineCoardinate[m - 1], this.lineCoardinate[m]];
          let line = await this.drawLine(arr, m, group.transitMode);
          this.plotPath = line;
          this.plotPath.setMap(this.googleMapObj);
          this.plottedLines.push(line);
        }
      }
    }
  }

  loadMap(group) {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 5,
          maxZoom: 17,
          center: new google.maps.LatLng(20.5937, 78.9629),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('locationMap'), mapOptions);
        this.customiseData(group);
      }, 100)
    } else {
      this.mapService.map("locationMap").then((map) => {
        this.locationMap = map;
        this.customiseData(group);
      }).catch((error) => {
        console.log(error)
      });
    }
  }
  closeTripDetails() {
    this.modalTitle = 'Trip update';
    this.isAnyChangesHere = false;
    this.statusFormSubmitted = false;
    this.openModal(this.selectedGroupIndex);

    if (this.selectedMap == 'google') {
      if (this.markersArray.length > 0) {
        this.clearOverlays();
      }
      if (this.plotPath) {
        this.plotPath.setMap(null);
      }
      this.empLocs = [];
      this.wayPoints = [];
    } else {
      this.locationMap.removeMarkerAll();
    }
    this.lineCoardinate = [];
    if (this.plottedLines.length > 0) {
      for (let i = 0; i < this.plottedLines.length; i++) {
        this.plottedLines[i].setMap(null);
      }
    }
    this.plottedLines = [];
  }

  drawLine(arr, index, transitMode) {
    return new Promise((res, rej) => {
      const lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        strokeColor: 'black',
        strokeWeight: 2,
        scale: 3
      };
      let line;
      if (index % 5 == 0 && index != 0) {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
          icons: [
            {
              icon: lineSymbol,
              offset: "50%",
            },
          ],
        })
      } else {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
        })
      }
      res(line);
    })
  }

  placeMarker(lat, lng, emp) {
    let latLng = new google.maps.LatLng(+lat, +lng);
    let image = {
      origin: new google.maps.Point(0, 0),
      scaledSize: new google.maps.Size(50, 50),
    };
    // let marker = new google.maps.Marker({
    //   position: latLng, 
    //   map: this.googleMapObj,
    // });
    let marker;
    if (emp.type == 'Branch') {
      image['url'] = "assets/images/map/branch.png";
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
        icon: image
      });

    } else {
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
      });
    }
    let infoWindowContent;
    let infowindow;
    marker.addListener('click', (e) => {
      if (infowindow) infowindow.close();
      if (emp.type == 'Employee') {
        if (emp.dd != undefined) {
          infoWindowContent = '<div class="window-content-container"><div>' + 'Drop point :' + '<span>' + ' ' + emp.dd + '</span></div><div style="margin-top:2px">' + 'Name :' + '<span>' + ' ' + emp.name + '</span></div><div style="margin-top:2px">' + 'Employee ID :' + ' ' + '<span>' + emp.ID.toUpperCase() + ' ' + '</span>' + '</div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + emp.mobile + ' ' + '</span>' + '</div>' + '</div>';
        }
        if (emp.pp != undefined) {
          infoWindowContent = '<div class="window-content-container"><div>' + 'Pickup point :' + '<span>' + ' ' + emp.pp + '</span></div><div style="margin-top:2px">' + 'Name :' + '<span>' + ' ' + emp.name + '</span></div><div style="margin-top:2px">' + 'Employee ID :' + ' ' + '<span>' + emp.ID.toUpperCase() + ' ' + '</span>' + '</div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + emp.mobile + ' ' + '</span>' + '</div>' + '</div>';
        }
      } else if (emp.type == 'Branch') {
        infoWindowContent = '<div class="window-content-container"><div>' + 'Branch :' + '<span>' + ' ' + emp.name + '</span>' + '</div></div>';
      }
      infowindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });
    })
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(this.googleMapObj, this);
    });
    this.markersArray.push(marker)
    if (emp.type == 'Branch') {
      this.googleMapObj.panTo(latLng);//for focusing marked location
    }
    if (emp.type == 'Branch') this.googleMapObj.setZoom(15);
  }

  clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++) {
      this.markersArray[i].setMap(null);
    }
    this.markersArray = [];
  }
  locationMarker(lat, lng) {
    if (this.locationMap != undefined) {
      this.markerId = 'pickLocation' + Math.round(Math.random() * 10000);
      lat = +lat.toFixed(5); lng = +lng.toFixed(5);
      this.locationMap.marker(
        {
          id: this.markerId,
          content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
          lat: lat,
          lng: lng,
        }
      );
      this.locationMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
      });
    }
  }
  closeMapModal() {
    if (this.selectedMap == 'google') {
      if (this.markersArray.length > 0) {
        this.clearOverlays();
      }
      if (this.plotPath) {
        this.plotPath.setMap(null);
      }
      this.empLocs = [];
      this.wayPoints = [];
    } else {
      this.locationMap.removeMarkerAll();
    }
    this.lineCoardinate = [];
    if (this.plottedLines.length > 0) {
      for (let i = 0; i < this.plottedLines.length; i++) {
        this.plottedLines[i].setMap(null);
      }
    }
    this.plottedLines = [];
  }
  filterChange(e: any) {
    if (e != 'All') {
      this.fleetData = this.fleetFilterData.filter(trip => trip?.tripStatus == e);

      if (e == 'yettostart') {
        this.fleetData = this.fleetFilterData.filter(trip => trip?.tripStatus == undefined);
      }
    }
    if (e == 'All') {
      this.fleetData = this.fleetFilterData;
    }
    console.log("fleet data for trip stauts:::::::", this.fleetData);

  }
  patchReason(e) {
    this.swapVehicleForm.controls.reason.setValue(e);
  }
  driverTripEnd(data: any) {
    this.endTripForm.reset();
    if (this.selectedGroup?.tripStatus == undefined) {
      this.endTripForm = this.formBuilder.group({
        startKlMtr: ['', [Validators.required]],
        tripEndKlMtr: ['', [Validators.required]]
      })
    }
  }
  async tripEndFunction() {

    if (this.endTripForm.valid && (this.endTripForm.value.tripEndKlMtr > this.endTripForm.value.startKlMtr)) {
      let end_time = new Date()
      let obj = {
        "vehRegNo": this.selectedGroup.vehRegNo,
        "rosterID": this.selectedGroup.rosterID,
        "location": { "lat": this.selectedGroup?.branchInfo?.location?.lat, "lng": this.selectedGroup?.branchInfo?.location?.lng },
        "driverInfo": {
          "name": this.selectedGroup.driverInfo.name,
          "mobile": this.selectedGroup.driverInfo.mobile ? this.selectedGroup.driverInfo.mobile : (this.selectedGroup.driverInfo.number
            ? this.selectedGroup.driverInfo.number
            : '---'),
          'driverID': this.selectedGroup.driverInfo['driverID']
        },
        "tripStatus": "end",
        "routeType": this.selectedGroup['routeType'] ?? 'roster',
        "tripDate": this.selectedGroup.tripDate,
        "tripStartTime": this.selectedGroup['tripStartTime'] ?? end_time.getTime(),
        "time": end_time.getTime(),
        "value": this.endTripForm.value.tripEndKlMtr,
        "tripSheetID": "",
        "shiftTime": this.selectedGroup?.shiftTime,
        "empIDs": [],
        "title": "",
        "startingKM": this.endTripForm.value.startKlMtr
      }

      await this.selectedGroup?.empInfo?.map(async (emp: any) => {
        obj['empIDs'].push(emp?.employeeID)
      });
      this.api.transportManagertripEnd(obj).then((res: any) => {
        if (res.status == 'Success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.enTripModalBtn.nativeElement.click();
          document.getElementById('closeModalBtn')?.click();
          this.endTripForm.reset();
        }
        if (res.status == 'failure') { this.swal.swalFunction(res.status, res.status, res.message, 2000); }
      });
    } else {
      this.endTripForm.markAllAsTouched();
      if (this.endTripForm.value['tripEndKlMtr'] && (this.endTripForm.value['tripEndKlMtr'] < this.endTripForm.value.startKlMtr)) {
        this.endTripForm.controls.tripEndKlMtr.setErrors({ notValid: true })
      }
    }

  }
  revertGroup(fleet, action) {
    let content = action == 'revert' ? 'You want to revert this group!' : 'You want to cancel this group!';
    Swal.fire({
      title: 'Are you sure?',
      text: content,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      confirmButtonText: 'Confirm'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = action === 'revert'
          ? { type: 'revert', rosterID: fleet?.rosterID }
          : { type: 'cancel', rosterID: fleet?.rosterID, vehRegNo: fleet?.vehRegNo };

        const apiMethod = action === 'revert'
          ? 'transportManagerGroupRevert'
          : 'transportManagerGroupCancel';

        this.api[apiMethod](obj).then((res: any) => {
          if (res.status == 'Success') {
            this.updateModalBtn.nativeElement.click();
            this.swal.swalFunction(res.status, res.status, res.message, 5000);
            this.refreshFleetManagement();
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    });
  }
}
